const WARN = 'border-warning-border bg-warning-muted text-warning';
const GOOD = 'border-success-border bg-success-muted text-success';
const ECTO = 'border-primary/40 bg-primary/10 text-primary';
const WRAITH = 'border-highlight/40 bg-highlight/15 text-highlight';
const EMBER = 'border-destructive/40 bg-destructive/10 text-destructive';
const QUIET = 'border-border bg-muted text-muted-foreground';

export const ORDER_STATUSES = ['Pending', 'Invoiced', 'Trial', 'Active', 'Cancelled'];

export const ORDER_STATUS_STYLES = {
  Pending: WARN,
  Invoiced: WRAITH,
  Trial: ECTO,
  Active: GOOD,
  Cancelled: QUIET,
};

export const TICKET_STATUSES = ['Open', 'Answered', 'Closed'];

export const TICKET_STATUS_STYLES = {
  Open: WARN,
  Answered: ECTO,
  Closed: QUIET,
};

export const TICKET_PRIORITIES = ['Low', 'Normal', 'Urgent'];

export const PRIORITY_STYLES = {
  Low: 'border-priority-low/40 bg-priority-low/10 text-priority-low',
  Normal: 'border-priority-medium/40 bg-priority-medium/10 text-priority-medium',
  Urgent: 'border-priority-high/40 bg-priority-high/10 text-priority-high',
};

export const TICKET_CATEGORIES = ['Setup', 'Billing', 'Playback', 'Account', 'Other'];

export const AUTHORS = ['Customer', 'Support'];

export const CONTACT_STATUSES = ['New', 'Replied', 'Archived'];

export const CONTACT_STATUS_STYLES = {
  New: WARN,
  Replied: GOOD,
  Archived: QUIET,
};

export const CONTACT_METHOD_VALUES = ['Discord', 'WhatsApp', 'Telegram'];

export const PAYMENT_KINDS = ['New', 'Renewal'];

export const PAYMENT_KIND_STYLES = {
  New: ECTO,
  Renewal: WRAITH,
};

export const DISCOUNT_KINDS = ['Percent', 'Fixed'];
export const DISCOUNT_PLANS = ['All', 'Demon', 'Wraith'];

export const CUSTOMER_TAGS = ['VIP', 'Late payer', 'Referrer', 'Family', 'Trial'];

export const ANNOUNCEMENT_TONES = ['Info', 'Promo', 'Outage'];

export const TONE_STYLES = {
  Info: ECTO,
  Promo: WRAITH,
  Outage: EMBER,
};

export const SHOW_ON = ['Site', 'Account', 'Both'];

export const TEMPLATE_KINDS = ['Credentials', 'Invoice', 'Expiry', 'Winback'];

export const TEMPLATE_KIND_STYLES = {
  Credentials: ECTO,
  Invoice: WRAITH,
  Expiry: WARN,
  Winback: EMBER,
};

export const TEMPLATE_PLACEHOLDERS = [
  '{name}',
  '{code}',
  '{server}',
  '{username}',
  '{password}',
  '{plan}',
  '{amount}',
  '{method}',
  '{ends}',
  '{discount}',
];

export const BROADCAST_KINDS = ['Service', 'Promo'];

export const BROADCAST_KIND_STYLES = {
  Service: ECTO,
  Promo: WRAITH,
};

export const AUDIENCES = ['All', 'Active', 'Expiring', 'Lapsed', 'Opted in'];

export const ACTIVITY_ACTIONS = ['Order', 'Payment', 'Ticket', 'Code', 'Email', 'Team'];

export const ACTIVITY_STYLES = {
  Order: ECTO,
  Payment: GOOD,
  Ticket: WARN,
  Code: WRAITH,
  Email: QUIET,
  Team: EMBER,
};

export const BOOL_STYLES = {
  Yes: GOOD,
  No: QUIET,
};
